import React from 'react';
import { API_BASE_URL, isProductionApi } from '../api';

/**
 * Avisa contra que API esta hablando el panel cuando no es la de produccion.
 * En produccion no renderiza nada.
 */
const EnvBanner = () => {
    if (isProductionApi()) return null;

    let host;
    try {
        host = new URL(API_BASE_URL).host;
    } catch {
        host = API_BASE_URL;
    }

    return (
        <div style={bannerStyle} role="status" data-testid="env-banner">
            AMBIENTE DE DESARROLLO — los datos que ves salen de <strong>{host}</strong>
        </div>
    );
};

const bannerStyle = {
    backgroundColor: '#B45309',
    color: '#FFFFFF',
    padding: '8px 16px',
    textAlign: 'center',
    fontSize: '14px',
    fontWeight: 500,
    letterSpacing: '0.02em',
};

export default EnvBanner;
